import { render, staticRenderFns } from "./SlotsForm.vue?vue&type=template&id=5871a50b&scoped=true&"
import script from "./SlotsForm.vue?vue&type=script&lang=js&"
export * from "./SlotsForm.vue?vue&type=script&lang=js&"
import style0 from "./SlotsForm.vue?vue&type=style&index=0&id=5871a50b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5871a50b",
  null
  
)

export default component.exports